import { ChangeEvent, useEffect, useState } from "react";

import { useTranslation } from "../../../../explorer/hooks/useTranslation";

import useBrands from "../../../../explorer/hooks/useBrands";
import { useExcelUtility } from "../../../../explorer/utils/ExcelUtils";
import { Box, Button, Chip, Link, Typography } from "@mui/material";
import AppIconsXls from "../../AppIcons/AppIconsXls";
import {
  themeSettings,
} from "../../../configuration/themeSettings";
import AppIconsDownload from "../../AppIcons/AppIconsDownload";
import { DialogDownloadTemplate } from "./DialogDownloadTemplate";

import { DialogCreateNewCart } from "./DialogCreateNewCart";
import {
  useClasses,
  StyledDataGrid,
  DialogContentStyled,
  StyledDialogActions,
  HeadContentTable,
} from "./BasketUpload.style";
import { ProgressPopup } from "../../../../explorer/components/ProgressPopup/ProgressPopup";

import {
  GridCallbackDetails,
  GridCellParams,
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
  GridRowId,
  GridRowSelectionModel,
  GridValidRowModel,
  MuiEvent,
  useGridApiRef,
} from "@mui/x-data-grid";

import StatusIconComponent from "./StatusIconComponent";
import { useBasketUpload } from "../../../hook/useBasketUpload";
import PartSketchThumbnailComponent from "../../PartsList/TableLayout/TableColumnComponents/PartSketchThumbnailComponent";
import { renderStatus, Status } from "./StatusItemUpoload";
import { renderImage } from "./ImageItemUpoload";
import CommonDialog from "../../CommonDialog/CommonDialog";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useApiNotification } from "../../../hook/useApiNotification";
import { useApiError } from "../../../hook/useApiError";
import { useBasket } from "../../../hook/useBasket";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { Basket, Brand } from "../../../../explorer/types";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import useGoToPage from "../../../hook/useGoToPage";
import { StatusType } from "../../../../explorer/types/Basket/BasketUploadPartInfo";
import AppIconsError from "../../AppIcons/AppIconsError";
import { ClassNames } from "@emotion/react";

export type BasketUploadProps = {
    onSave: any;
    onClose: any;
    reloadPrice:any;
};

export const BasketUpload = (props: BasketUploadProps) => {
  const [mergingPopupOpen, setMergingPopupOpen] = useState(false);

  const apiRef = useGridApiRef();

  const [errorNumber, setErrorNumber] = useState(0);
  const [hasContent, setHasContent] = useState(false);
  const [hasValidParts, setHasValidParts] = useState(false);

  const { t } = useTranslation();
  
  const brands = useBrands().brands;
  const currentBrand = useBrands().currentBrand;


  const basketUpload = useBasketUpload();
  const [baskets, setBaskets] = useReduxState<Basket[]>(
    reduxStoreConfig.basketBaskets
  );
  

  // const [currentBasket, setCurrentBasket] = useReduxState<Basket>(
  //   reduxStoreConfig.basketCurrentBasket
  // );
  const columns: GridColDef[] = [
      {
          field: "selectRow",
          headerName: "",
          align: "center",
          headerAlign: "center",
          width: 50,
          cellClassName: "primaryColor",
          headerClassName: "icon",
          renderHeader: (params: GridColumnHeaderParams) => (
              <Box
                  sx={classes.leftTopCorner}
                  className="leftTopCorner"
                  onClick={() => {
                      basketUpload.handleSelectAllCells();
                  }}
              >
                  {" "}
              </Box>
          ),
          renderCell: (params: GridRenderCellParams) => (
              <Box
                  onClick={() => {
                      basketUpload.handleRowSelection(params);
                  }}
              >
                  {params.row.id + 1}
              </Box>
          ),
      },
      {
          type: "string",
          field: "itemCode",
          headerName: t("common.spareparts.part.code")
              .toString()
              .toLocaleUpperCase(),
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          editable: true,
      },

      {
          type: "string",
          field: "quantity",
          headerName: t("common.spareparts.part.qty")
              .toString()
              .toLocaleUpperCase(),
          align: "right",
          width: 60,
          minWidth: 60,
          maxWidth: 60,
          editable: true,
      },
      {
          type: "singleSelect",
          field: "manufacturerCompanyCode",
          headerName: t("common.spareparts.part.mcc")
              .toString()
              .toLocaleUpperCase(),
          align: "right",
          width: 115,
          minWidth: 115,
          maxWidth: 115,
          editable: true,
          getOptionValue: (value: any) => value.code,
          getOptionLabel: (value: any) => value.code,
          valueOptions: [
              //{code:"",descr:""}, // Blank first record
              ...currentBrand!.manufacturers.map((manufacturer) => ({
                  code: manufacturer.code,
                  descr: manufacturer.descr,
              })),
          ],
      },
      {
          type: "string",
          field: "replacementCode",
          headerName: t("common.spareparts.part.withreplacement")
              .toString()
              .toLocaleUpperCase(),
          width: 125,
          minWidth: 125,
          maxWidth: 125,
      },

      {
          type: "string",
          field: "status",
          headerName: "",
          width: 35,
          minWidth: 35,
          maxWidth: 35,
          renderCell: renderStatus,
      },
      {
          type: "string",
          field: "images",
          headerName: "",
          width: 40,
          minWidth: 40,
          maxWidth: 40,
          cellClassName: "primaryColor",
          renderCell: renderImage,
      },
      {
          type: "string",
          field: "description",
          headerName: t("common.spareparts.part.description")
              .toString()
              .toLocaleUpperCase(),
          width: 410,
          minWidth: 410,
          maxWidth: 410,
      },
  ];

  const  getManufactures= () => {
          


  }
  useEffect(() => {
   
    basketUpload.setColums(columns);
  }, []);

  useEffect(() => {
    setErrorNumber(basketUpload.hasErrorParts);
    if (basketUpload.data[apiRef.current.getRowsCount() - 1].itemCode !== "") {
      if (apiRef.current.getRowsCount() >= basketUpload.MAX_ROWS) {
        /*
        setGeneralErrorMessage(
            t("basket.items.MaxItemsExceeded_upload") +
                " (" +
                basketUpload.MAX_ROWS +
                ")"
        );
        setGeneralErrorDialogOpen(true);
        */
      } else {
        basketUpload.addNewEmptyRows(apiRef.current.getRowsCount());
      }
    }
  }, [basketUpload.data]);
  const reportHeaders = [
    {
      label: t("common.spareparts.part.code").toString(),
      key: "code",
    },
    { label: t("common.spareparts.part.qty").toString(), key: "qty" },
    {
      label: t("common.spareparts.part.status").toString(),
      key: "status",
    },
    {
      label: t("common.spareparts.part.comments").toString(),
      key: "note",
    },
    {
      label: t("common.spareparts.part.qty").toString(),
      key: "qty2Nd",
    },
    {
      label: t("common.spareparts.part.description").toString(),
      key: "description",
    },
  ];

  const classes = useClasses();
  const excelUtility = useExcelUtility();

  const handleUploadFile = (event: any) => {
    document.getElementById("uploadFileBasket")?.click();
  };

  const [importErrorDialogOpen, setImportErrorDialogOpen] = useState(false);
  const handleImportErrorDialogClose = () => {
    setImportErrorDialogOpen(false);
  };

  function excelFileHandler(event: ChangeEvent<HTMLInputElement>): void {
    if (event.target.files == null) return;
    let fileObj = event.target.files[0];
    let target = event.target;

    //just pas  s the fileObj as parameter
    try {
      setMergingPopupOpen(true);
      excelUtility.excelRenderer(fileObj, (err: any, resp: any) => {
        if (err) {
          setImportErrorDialogOpen(true);
        } else {
          // E necessario?
          /*
          if (resp.cols.length > 2) {
            setImportErrorDialogOpen(true);
            target.value = "";
            setMergingPopupOpen(false);
            return;
          }
          */
          const newData: string[][] = resp.rows
              .slice(1)
              .map((row: { toString: () => any }[]) => [
                  "" + row[0],
                  row[1] !== undefined //&& Number.isInteger(row[1])
                      ? row[1].toString()
                      : "1",
                  row[2] !== undefined 
                      ? row[2].toString()
                      : "",
              ])
              .filter(
                  (row: { toString: () => any }[]) =>
                      row[0] !== "undefined" && row[0] != ""
              );
          if (newData.length > basketUpload.MAX_ROWS) {
            setGeneralErrorMessage(
                t("basket.items.MaxItemsExceeded_upload") +
                    " (" +
                    basketUpload.MAX_ROWS +
                    ")"
            );
            setGeneralErrorDialogOpen(true);
          } else {
            basketUpload.updateDataUploaded(newData);
          }
        }

        target.value = "";
      });
    } catch (e) {
      setMergingPopupOpen(false);
      setImportErrorDialogOpen(true);
    }
    setMergingPopupOpen(false);
  }

  const handleExportTemplate = () => {
    const headers = [
      { label: t("common.spareparts.part.code"), key: "code" },
      { label: t("common.spareparts.part.qty"), key: "qty" },
      { label: t("common.spareparts.part.mcc"), key: "mcc" },
      

    ];

    excelUtility.exportToExcel(
        headers,
        [],
        "shopping_basket_import_template ",
        "basket",
        [
            { wch: 20 },
            { wch: 5 },
            { wch: 15 },
      
        ]
    );
  };

  const [generalErrorDialogOpen, setGeneralErrorDialogOpen] =
    useState<boolean>(false);

  const handleGeneralErrorDialogClose = () => {
    setGeneralErrorDialogOpen(false);
  };

  const [generalErrorMessage, setGeneralErrorMessage] = useState<string>("");

  const [uploadNoContentDialogOpen, setUploadNoContentDialogOpen] =
    useState<boolean>(false);

  const handleUploadNoContentDialogClose = () => {
    setUploadNoContentDialogOpen(false);
  };

  const [uploadWithErrorDialogOpen, setUploadWithErrorDialogOpen] =
    useState(false);
  const handleUploadWithErrorDialogClose = () => {
    setUploadWithErrorDialogOpen(false);
  };
  const [uploadCreateBasketDialogOpen, setUploadCreateBasketDialogOpen] =
    useState(false);

  const handleUploadCreateBasketDialogClose = () => {
    setUploadCreateBasketDialogOpen(false);
  };

  const [newBasketId, setNewBasketId] = useState<number>();

  async function handleUploadWithErrorDialogConfirm(): Promise<void> {
    if (!isCurrentlyCreate) {
      const result: string = await basketUpload.handleSaveOrMergeFinal(
        false,
        newBasketId!
      );
      if (result == "true") {
        setNotification(
            t(
                !isCurrentlyCreate
                    ? "common.basket.itemsAddedSelctedBasket"
                    : "common.basket.itemsAddedNewBasket"
            )
        );
        props.reloadPrice();
        props.onSave();
        props.onClose();
        handleUploadWithErrorDialogClose();
      } else {
        setError(result);
      }
    } else {
      setUploadCreateBasketDialogOpen(true);
    }
  }

  const [isCurrentlyCreate, setIsCurrentlyCreate] = useState(false);
  const [error, setError] = useApiError();
  const [notification, setNotification] = useApiNotification();

  async function handleMergeBasket(): Promise<void> {
    if (basketUpload.hasValidParts()) {
      if (basketUpload.hasErrorParts()) {
        setIsCurrentlyCreate(false);
        setUploadWithErrorDialogOpen(true);
      } else {
        const result: string = await basketUpload.handleSaveOrMergeFinal(
          false,
          null
        );
        if (result == "true") {
          setNotification(t("common.basket.itemsAddedSelctedBasket"));
   
          props.reloadPrice();
          props.onSave();
          props.onClose();
        } else {
          setError(result);
        }
      }
    } else {
      setUploadNoContentDialogOpen(true);
    }
  }

  const handleCreateNewBasket = async () => {
    if (basketUpload.hasValidParts()) {
      if (basketUpload.hasErrorParts()) {
        setIsCurrentlyCreate(true);
        setUploadWithErrorDialogOpen(true);
      } else {
        setUploadCreateBasketDialogOpen(true);
      }
    } else {
      setUploadNoContentDialogOpen(true);
    }
  };

  const basketOperation = useBasket();
  const goToPage = useGoToPage();

  const handleSaveNewBasket = async (basketId: number) => {
    const result: string = await basketUpload.handleSaveOrMergeFinal(
      true,
      basketId
    );

    if (result == "true") {
      setNotification(t("common.basket.itemsAddedNewBasket"));
      //const _baskets = await basketOperation.saveCurrentBasket(basketId);
      //setBaskets(_baskets);
      //var newBasketSelected = _baskets.find((x) => x.id === basketId);
      
      basketOperation.changeCurrentBasket(basketId);
      //setCurrentBasket(newBasketSelected!);
      handleUploadWithErrorDialogClose();
      props.onSave();
      props.onClose();
    } else {
      setError(result);
    }
  };

  const handleProcessRowUpdate = (
    newRow: GridValidRowModel,
    oldRow: GridValidRowModel,
    params: { rowId: GridRowId }
  ) => {
    const _return: any = basketUpload.processRowUpdate(newRow, oldRow);
    return _return;
  };

  const handlePaste = async (event: React.ClipboardEvent<HTMLDivElement>) => {
    apiRef.current.setCellFocus(0, "");
    if (!(await basketUpload.handlePaste(event))) {
      setGeneralErrorMessage(
          t("basket.items.MaxItemsExceeded_upload") +
              " (" +
              basketUpload.MAX_ROWS +
              ")"
      );
      setGeneralErrorDialogOpen(true);
    }
  };

  function handleProcessRowUpdateError(error: any): void {
    alert("Function not implemented.");
  } 

  return (
      <>
          {" "}
          <DialogContentStyled>
              <HeadContentTable>
                  <div>
                      <Typography sx={{ fontSize: 14 }}>
                          {t(
                              "common.spareparts.basket.upload.description_upload_xls"
                          )}
                      </Typography>
                      <Typography
                          sx={{ fontSize: 14 }}
                          noWrap={true}
                          component="div"
                      >
                          {t(
                              "common.spareparts.basket.upload.upload_message_content"
                          )
                              .toString()
                              .replace(
                                  "###MAX_ROWS###",
                                  "" + basketUpload.MAX_ROWS
                              )}
                      </Typography>
                      <Link
                      
                          color="primary"
                          onClick={(event: any) => {
                              event.preventDefault();
                              event.stopPropagation();
                              handleExportTemplate();
                              return false;
                          }}
                      >
                          <Box
                              sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingTop: "7px",
                                  alignItems: 'center',
                                  cursor: 'pointer',
                              }}
                          >
                              <AppIconsDownload
                                  sx={{
                                      paddingRight: "7px",
                                  }}
                              />
                              <Typography  sx={{ fontSize: 14 }}>
                                  {t(
                                      "common.spareparts.basket.upload.download_template_xls"
                                  )}
                              </Typography>
                          </Box>
                      </Link>
                  </div>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Button
                          variant="contained"
                          color="primary"
                          size="medium"
                          startIcon={<AppIconsXls />}
                          onClick={handleUploadFile}
                          sx={{ minWidth: "175px" }}
                      >
                          <Typography variant="button">
                              {t("common.spareparts.basket.upload.button")}
                          </Typography>
                      </Button>
                      <Box>
                          <input
                              id="uploadFileBasket"
                              type="file"
                              accept=".xlsx"
                              onChange={excelFileHandler}
                              style={{ display: "none" }}
                          />
                      </Box>
                  </Box>
              </HeadContentTable>

              {/*data={data}*/}

              <Box sx={classes.excel} style={{ height: 370 }}>
                  {columns !== undefined && (
                      <>
                          <StyledDataGrid
                              apiRef={apiRef}
                              columnHeaderHeight={25}
                              rowHeight={25}
                              autosizeOptions={{
                                  columns: ["description"],
                                  includeOutliers: true,
                                  includeHeaders: true,
                              }}
                              disableColumnSorting
                              disableColumnMenu
                              pagination={undefined}
                              rows={basketUpload.data}
                              columns={columns}
                              slotProps={{
                                  cell: {
                                      onPaste: handlePaste,
                                      onMouseDown: basketUpload.handleMouseDown,
                                      onMouseUp: basketUpload.handleMouseUp,
                                      onMouseEnter:
                                          basketUpload.handleMouseEnter,
                                  },
                              }}
                              onCellClick={(
                                  params: GridCellParams,
                                  event: MuiEvent<React.MouseEvent>
                              ) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  event.defaultMuiPrevented = true;
                                  if (+params.id + 1 > basketUpload.MAX_ROWS) {
                                      setGeneralErrorMessage(
                                          t(
                                              "basket.items.MaxItemsExceeded_upload"
                                          ) +
                                              " (" +
                                              basketUpload.MAX_ROWS +
                                              ")"
                                      );
                                      setGeneralErrorDialogOpen(true);
                                  } else {
                                      return params.row.fields == "selectRow"
                                          ? basketUpload.handleCellClick(params) //basketUpload.handleRowSelection(params)
                                          : basketUpload.handleCellClick(
                                                params
                                            );
                                  }
                              }}
                              onCellKeyDown={(
                                  params: GridCellParams,
                                  event: any
                              ) => {
                                  if (event.key === "Delete") {
                                      console.log(event);
                                      event.preventDefault();
                                      event.stopPropagation();
                                      basketUpload.handleCellDelete();
                                  }
                              }}
                              processRowUpdate={handleProcessRowUpdate}
                              getCellClassName={(params) =>
                                  basketUpload.isCellSelected(
                                      params.id,
                                      params.field
                                  )
                                      ? basketUpload.getCssClassSelected(
                                            params.id,
                                            params.field
                                        ) + " selected-cell" //"top left "
                                      : params.id === basketUpload.selectedRow
                                      ? "selected-row"
                                      : ""
                              }
                          />
                      </>
                  )}
              </Box>
          </DialogContentStyled>
          <StyledDialogActions>
              <div
              
                  style={{
                      visibility: errorNumber > 0 ? "unset" : "hidden",
                  }}
              >
                  <Typography color="error" noWrap={true}>
                      {t("common.spareparts.basket.upload.upload_error_msg")
                          .toString()
                          .split("###IMG_ERROR###")[0]
                          .replace("###N_ERROR###", "" + errorNumber)}
                      <Status code={StatusType.Error} message="" />
                  </Typography>
              </div>

              <div>
                  <Button
                      variant="outlined"
                      color="primary"
                      size="medium"
                      onClick={handleCreateNewBasket}
                  >
                      <Typography variant="button">
                          {t(
                              "common.spareparts.basket.upload.uploadNew_button"
                          )}
                      </Typography>
                  </Button>
                  <Button
                      variant="contained"
                      color="primary"
                      size="medium"
                      onClick={handleMergeBasket}
                      style={{ marginLeft: 15, minWidth: "175px" }}
                  >
                      <Typography variant="button">
                          {t(
                              "common.spareparts.basket.upload.uploadMerge_button"
                          )}
                      </Typography>
                  </Button>
              </div>
          </StyledDialogActions>
          <DialogDownloadTemplate
              handleImportErrorDialogClose={handleImportErrorDialogClose}
              importErrorDialogOpen={importErrorDialogOpen}
              handleExportTemplate={handleExportTemplate}
          />
          <CommonDialog
              open={generalErrorDialogOpen}
              dialogTitleLabel="alert.title.warning"
              closeDialog={handleGeneralErrorDialogClose}
              useDenyBtn={false}
              confirmButtonText={"common.ok"}
              confirmButton={handleGeneralErrorDialogClose}
          >
              <Typography sx={{ fontSize: 14,}}>{generalErrorMessage}</Typography>
          </CommonDialog>
          <CommonDialog
              open={uploadNoContentDialogOpen}
              closeDialog={handleUploadNoContentDialogClose}
              dialogContentLabel="common.spareparts.basket.error_upload_no_part"
              dialogTitleLabel="basket.upload.popuo_title"
              useDenyBtn={false}
              confirmButtonText={"common.ok"}
              confirmButton={handleUploadNoContentDialogClose}
          ></CommonDialog>
          <DialogCreateNewCart
              open={uploadCreateBasketDialogOpen}
              onClose={() => {
                  handleUploadCreateBasketDialogClose();
              }}
              onSave={(value: number) => {
                  handleSaveNewBasket(value);
              }}
          />
          <CommonDialog
              open={uploadWithErrorDialogOpen}
              closeDialog={handleUploadWithErrorDialogClose}
              dialogTitleLabel="basket.upload.popuo_title"
              useDenyBtn={true}
              denyButtonText={"common.cancel"}
              confirmButtonText={"common.continue"}
              confirmButton={handleUploadWithErrorDialogConfirm}
          >
              <Box sx={{ display: "flex" }}>
                  <AppIconsError
                      sx={{
                          color: themeSettings.main.palette.error.main,
                      }}
                  />
                  <Typography sx={{ paddingLeft: "5px" }}>
                      {t("basket.upload_warning_message_confirm")
                          .toString()
                          .replace("###IMG_ERROR###", "")
                          .replace("###N_ERROR###", "" + errorNumber)}
                  </Typography>
              </Box>
          </CommonDialog>
          <ProgressPopup
              open={mergingPopupOpen}
              label="common.spareparts.loading"
          />
      </>
  );
};
